module.exports = __webpack_public_path__ + "img/Avatar_.71af79c9.png";